// extracted by mini-css-extract-plugin
export default {"cancelSearchButton":"MusicHomeSearchControlResetButton_cancelSearchButton__MMBNQ"};